import { useState, useEffect } from "react"
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faXmark, faAngleLeft, faCircleNotch } from '@fortawesome/free-solid-svg-icons'
import Select from "react-select";
import { useUser } from "../utils/UserContext";
import { toast } from 'react-hot-toast';
import Modal from 'react-modal';
import Switch from "react-switch";

function DepositSettings({depositBar, toggleDepositBar }) {
    const { user } = useUser();
    const [loading, setLoading] = useState(false);
    const [disable, setDisable] = useState(true);
    const [methodoptions, setMethodoptions] = useState([]);
    const [methodoptions1, setMethodoptions1] = useState([]);
    const [modalIsOpen, setIsOpen] = useState(false);
    const [checked, setChecked] = useState();
    const [modalIsOpen1, setIsOpen1] = useState(false);
    const [disable1, setDisable1] = useState(true);
    const [loading1, setLoading1] = useState(false);
    const [loading2, setLoading2] = useState(false);

    const [naddress, setNaddress] = useState("");
    const [nnetwork, setNnetwork] = useState("");
    const [ncoin, setNcoin] = useState("");
    const [ocoin, setOcoin] = useState("");
    const [onetwork, setOnetwork] = useState("");

    const [type, setType] = useState("");
    const [address, setAddress] = useState("");
    const [network, setNetwork] = useState("");
    const [coin, setCoin] = useState("");
    const [crypto, setCrypto] = useState([]);
    
  useEffect(() => {
    fetch(`${process.env.REACT_APP_API_URL}controller/fetch.controller.php`, {
      credentials: "include",
      method: "POST",
      headers: {
        "Content-Type": "application/json"
      },
      body: JSON.stringify({ fetchadmin: true })
    })
    .then(response => response.json())
    .then(data => {
      if (data.status === "success") {
        setChecked(data.admin.manual_deposit);
      }
    })
    .catch(err => {
    })
  }, [user]);

  const validateManual = (status, setStatus) => {
    const newValue = status ? "0" : "1";
    fetch(`${process.env.REACT_APP_API_URL}controller/manage.controller.php`, {
      credentials: "include",
      method: "POST",
      headers: {
        "Content-Type": "application/json"
      },
      body: JSON.stringify({ 
        btn_manual: true, 
        status: newValue 
      })
    })
    .then(response => response.json())
    .then(data => {
      if (data.status === "success") {
        setStatus(!status);
        toast.success(data.result);
      } else {
        toast.error(data.message);
      }
    })
    .catch(err => {
    });
  };

    useEffect(() => {
        if(naddress && nnetwork && ncoin){
          setDisable1(false);
        }else{
          setDisable1(true);
        }
      }, [naddress, nnetwork, ncoin]);
    useEffect(() => {
        if(address && network && coin){
          setDisable(false);
        }else{
          setDisable(true);
        }
    }, [address, network, coin]);
    useEffect(() => {
        fetch(`${process.env.REACT_APP_API_URL}controller/fetch.controller.php`, {
          credentials: "include",
          method: "POST",
          headers: {
            "Content-Type": "application/json"
          },
          body: JSON.stringify({ fetchaddress1: true })
        })
        .then(response =>  response.json())
        .then(data => {
          const methodop = []
          if (data.status === "success") {
            data.address.forEach(address => {
              methodop.push({
                id: address.id,
                value: address.value,
                logo: address.logo,
                address: address.address,
                network: address.network,
                symbol: address.symbol
              });
            });
            setMethodoptions(methodop);
          }
        })
        .catch(err => {
          console.error('Error fetching deposit wallet:', err);
        })
    }, [user]);
    useEffect(() => {
        fetch(`${process.env.REACT_APP_API_URL}controller/fetch.controller.php`, {
          credentials: "include",
          method: "POST",
          headers: {
            "Content-Type": "application/json"
          },
          body: JSON.stringify({ fetchsaddress1: true })
        })
        .then(response =>  response.json())
        .then(data => {
          const methodop = []
          if (data.status === "success") {
            data.address.forEach(address => {
              methodop.push({
                id: address.id,
                value: address.value,
                logo: address.logo,
                address: address.address,
                network: address.network,
                symbol: address.symbol
              });
            });
            setMethodoptions1(methodop);
          }
        })
        .catch(err => {
          console.error('Error fetching deposit wallet:', err);
        })
    }, [user]);
    useEffect(() => {
        fetch(`/coin_list.txt`)
        .then((res) => res.json())
        .then((data) => {
        var coinList = data.data;
        const updatedData = coinList.map((coin, index) => ({
            id: index + 1,
            value: coin.symbol,
            name: coin.name,
            label: (
              <>
                <img src={`https://s2.coinmarketcap.com/static/img/coins/64x64/${coin.id}.png`} alt={coin.symbol} width="20" style={{ marginRight: 5 }} />
                {coin.symbol}
              </>
            ),
            logo: `https://s2.coinmarketcap.com/static/img/coins/64x64/${coin.id}.png`,
        }));
        setCrypto(updatedData);
        })
        .catch((err) => console.error("Error loading coin list:", err));
    }, []);
    const setEditAddress = (network, address, coin, type) =>{
        setOnetwork(network);
        setNnetwork(network);
        setNaddress(address);
        setOcoin(coin);
        setNcoin(coin);
        setIsOpen1(true);
        if(type == "first"){
          setType("Regular");
        }else{
          setType("Signal");
        }
    }
    const EditAddress = () =>{
        setLoading1(true);
        fetch(`${process.env.REACT_APP_API_URL}controller/fetch.controller.php`, {
          credentials: "include",
          method: "POST",
          headers: {
            "Content-Type": "application/json"
          },
          body: JSON.stringify({ btn_editaddress: true, address : naddress, coin : ncoin, network : nnetwork, old_coin : ocoin, old_network : onetwork, type :type})
        })
        .then(response => response.json())
        .then(data => {
          console.log(data);
          if (data.status === "success") {
            toast.success(data.result);
            setIsOpen1(false);
            setTimeout(() => {
              window.location.href = "deposit";
            }, 2000);
          }else{
            toast.error(data.message);
          }
          setLoading1(false);
        })
        .catch(err => {
          console.error(err)
          setLoading1(false);
        })
    }
    const AddAddress = () =>{
        setLoading(true);
        fetch(`${process.env.REACT_APP_API_URL}controller/fetch.controller.php`, {
          credentials: "include",
          method: "POST",
          headers: {
            "Content-Type": "application/json"
          },
          body: JSON.stringify({ btn_addcoin: true, address : address, coin : coin, network : network, type :type})
        })
        .then(response => response.json())
        .then(data => {
          if (data.status === "success") {
            toast.success(data.result);
            setTimeout(() => {
                window.location.href = "deposit";
            }, 2000);
          }else{
            toast.error(data.message);
          }
          setLoading(false);
        })
        .catch(err => {
          console.error(err)
          setLoading(false);
        })
    }
    const DeleteAddress = () =>{
        setLoading2(true);
        fetch(`${process.env.REACT_APP_API_URL}controller/fetch.controller.php`, {
          credentials: "include",
          method: "POST",
          headers: {
            "Content-Type": "application/json"
          },
          body: JSON.stringify({ btn_deleteaddress: true, coin : ncoin, network : nnetwork, type :type})
        })
        .then(response => response.json())
        .then(data => {
          if (data.status === "success") {
            toast.success(data.result);
            setTimeout(() => {
              window.location.href = "deposit";
            }, 2000);
          }else{
            toast.error(data.message);
          }
          setLoading2(false);
        })
        .catch(err => {
          console.error(err)
          setLoading2(false);
        })
      }
      const darkThemeStyles = {
        control: (styles) => ({
          ...styles,
          backgroundColor: "#151719",
          border: "none",
          color: "#fff",
        }),
        menu: (styles) => ({
          ...styles,
          backgroundColor: "#151719",
        }),
        option: (styles, { isFocused, isSelected }) => ({
          ...styles,
          backgroundColor: isSelected ? "rgb(30, 33, 36)" : isFocused ? "rgb(30, 33, 36)" : "#151719",
          color: "#fff",
        }),
        singleValue: (styles) => ({
          ...styles,
          color: "#fff",
        }),
    };
    return (
    <div className={`notifybar ${depositBar ? "active" : null}`}>
        <div className="d-flex align-items-center justify-content-between">
            <div className="d-flex align-items-center" style={{cursor: 'pointer'}}>
                <FontAwesomeIcon icon={faAngleLeft} style={{color: 'white', cursor: 'pointer', fontSize: '14px'}} onClick={() => {toggleDepositBar()}}/>
                <p className="mb-0 fw-semibold ms-3 text-white">Deposit Settings</p>
            </div> 
            <FontAwesomeIcon icon={faXmark} style={{color: 'gray', cursor: 'pointer', fontSize: '20px'}} onClick={() => {toggleDepositBar()}}/>
        </div>
        <div className="sidebar-navbar" style={{height: 'auto', paddingBottom: '200px'}}>
            <p className="mb-0 fw-semibold">Crypto settings <span className="fw-normal" style={{color:'lightgray',fontSize: '14px'}}>(Regular deposit)</span></p>
            <p className="mb-0" style={{fontSize: '12px',color:'lightgray'}}>Edit your regular crypto deposit settings</p>
            <label className="fw-semibold mb-1 mt-2" style={{fontSize: '13px',color:'#d1d6e0b3'}}>Addresses:</label>
            {
            methodoptions.map((option, idx) => {
                return (
                <div key={idx} className="d-flex align-items-center justify-content-between mb-2">
                    <div className="rounded-3 py-2 px-3 d-flex align-items-center" style={{backgroundColor:'#ffffff06',width:'85%'}}>
                    <img src={option.logo} alt={option.symbol} style={{width:'20px'}}/>
                    <div className="ms-2">
                        <p className="mb-0 fw-semibold lh-1" style={{fontSize:'14px'}}>{option.value} - {option.network}</p>
                        <p className="mb-0 lh-1" style={{fontSize: '12px',color:'lightgray'}}>{option.address ? option.address.slice(0, 10) + '...' + option.address.slice(-4) : ''}</p>
                    </div>
                    </div>
                    <div 
                    className="rounded-3 d-flex align-items-center justify-content-center" 
                    onClick={() => setEditAddress(option.network, option.address, option.symbol, "first")} 
                    style={{cursor:'pointer',height:'40px',width:'43px',backgroundColor:'#ffffff3d'}}
                    >
                    Edit
                    </div>
                </div>
                );
            })
            }
            <div onClick={() => {setIsOpen(true); setType("Regular");}} className="myBtn w-100 text-center mt-3 bg-prime" style={{paddingTop:'0.8rem',paddingBottom:'0.8rem'}}>Add new wallet address</div>
            <label className="fw-semibold mb-0 d-block mt-3 mb-1" style={{fontSize: '14px'}}>Deposit (Signal/Subscription deposit)</label>
            <div className="itemcard1 d-flex justify-content-between align-items-center mb-3">
                <p className="mb-0" style={{color: 'lightgray', fontSize:'14px'}}>Use the same address as regular deposit</p>
                <Switch
                    onChange={() => validateManual(checked, setChecked)}
                    checked={checked}
                    offColor="#404448"
                    onColor="#404448"
                    offHandleColor="#8c95a0"
                    onHandleColor="#ff6b35"
                    uncheckedIcon={false}
                    checkedIcon={false}
                    height={23}
                    width={40}
                    handleDiameter={18}
                />
            </div>
            <label className="fw-semibold mb-1" style={{fontSize: '13px',color:'#d1d6e0b3'}}>Addresses:</label>
            {
            methodoptions1.map((option, idx) => {
                return (
                <div key={idx} className="d-flex align-items-center justify-content-between mb-2">
                    <div className="rounded-3 py-2 px-3 d-flex align-items-center" style={{backgroundColor:'#ffffff06',width:'85%'}}>
                    <img src={option.logo} alt={option.symbol} style={{width:'20px'}}/>
                    <div className="ms-2">
                        <p className="mb-0 fw-semibold lh-1" style={{fontSize:'14px'}}>{option.value} - {option.network}</p>
                        <p className="mb-0 lh-1" style={{fontSize: '12px',color:'lightgray'}}>{option.address ? option.address.slice(0, 10) + '...' + option.address.slice(-4) : ''}</p>
                    </div>
                    </div>
                    <div 
                    className="rounded-3 d-flex align-items-center justify-content-center" 
                    onClick={() => setEditAddress(option.network, option.address, option.symbol, "second")} 
                    style={{cursor:'pointer',height:'40px',width:'43px',backgroundColor:'#ffffff3d'}}
                    >
                    Edit
                    </div>
                </div>
                );
            })
            }
            <div onClick={() => { setIsOpen(true); setType("Signal");}} className="myBtn w-100 text-center mt-3 bg-prime" style={{paddingTop:'0.8rem',paddingBottom:'0.8rem'}}>Add new wallet address</div>
        </div>
        <Modal
            isOpen={modalIsOpen}
            onRequestClose={() => setIsOpen(false)}
            shouldCloseOnOverlayClick={true} 
            closeTimeoutMS={100}
            className="shortmode"
        >
          <div className="d-flex align-items-center justify-content-between">
              <p className="mb-0 fw-bold text-white" style={{fontSize: '16px'}}>Add new address</p>
              <FontAwesomeIcon className="py-1 px-2 rounded-3" icon={faXmark} style={{fontSize: '15px', backgroundColor: 'rgba(255, 255, 255, 0.1)', cursor: 'pointer'}} onClick={() => setIsOpen(false)} />
          </div>
          <label className="fw-semibold mt-2 mb-1" style={{fontSize: '14px'}}>Type:</label>
            <Select 
                options={crypto} 
                value={crypto.find((opt) => opt.value === coin)}
                onChange={(selected) => {
                    setCoin(selected.value); 
                }}
                isSearchable
                styles={darkThemeStyles}
                className="w-full"
            />
          <label className="fw-semibold mb-1 mt-2" style={{fontSize: '14px'}}>Network:</label>
          <div className="form-control py-2">
              <input 
                type="text"
                placeholder="TRC20"
                className="inputNone"
                value={network}
                onChange={(e) => setNetwork(e.target.value)}
              />
          </div>
          <label className="fw-semibold mb-1 mt-2" style={{fontSize: '14px'}}>Address:</label>
          <div className="form-control py-2">
              <input 
                type="text"
                placeholder="TRC20"
                className="inputNone"
                value={address}
                onChange={(e) => setAddress(e.target.value)}
              />
          </div>
          <div className={`myBtn w-100 text-center mt-5 bg-prime ${disable?'disabled':null}`} style={{paddingTop: '12px',paddingBottom: '12px'}} onClick={!disable ? AddAddress : null}>{loading?<FontAwesomeIcon icon={faCircleNotch} style={{fontSize: '20px', color: 'white', opacity: '0.5'}} spin />:'Save'}</div>
        </Modal>
        <Modal
            isOpen={modalIsOpen1}
            onRequestClose={() => setIsOpen1(false)}
            shouldCloseOnOverlayClick={true} 
            closeTimeoutMS={100}
            className="shortmode"
        >
          <div className="d-flex align-items-center justify-content-between">
              <p className="mb-0 fw-bold text-white" style={{fontSize: '16px'}}>Edit Regular address</p>
              <FontAwesomeIcon className="py-1 px-2 rounded-3" icon={faXmark} style={{fontSize: '15px', backgroundColor: 'rgba(255, 255, 255, 0.1)', cursor: 'pointer'}} onClick={() => setIsOpen1(false)} />
          </div>
          <label className="fw-semibold mt-2 mb-1" style={{fontSize: '14px'}}>Type:</label>
            <Select 
                options={crypto} 
                value={crypto.find((opt) => opt.value === ncoin)}
                onChange={(selected) => {
                    setNcoin(selected.value); 
                }}
                isSearchable
                styles={darkThemeStyles}
                className="w-full"
            />
          <label className="fw-semibold mb-1 mt-2" style={{fontSize: '14px'}}>Network:</label>
          <div className="form-control py-2">
              <input 
                type="text"
                placeholder="TRC20"
                className="inputNone"
                value={nnetwork}
                onChange={(e) => setNnetwork(e.target.value)}
              />
          </div>
          <label className="fw-semibold mb-1 mt-2" style={{fontSize: '14px'}}>Address:</label>
          <div className="form-control py-2">
              <input 
                type="text"
                placeholder="TRC20"
                className="inputNone"
                value={naddress}
                onChange={(e) => setNaddress(e.target.value)}
              />
          </div>
          <div className="d-flex align-items- justify-content-between" style={{gap: '10px'}}>
            <div className={`myBtn w-100 text-center mt-5 bg-danger`} style={{paddingTop: '12px',paddingBottom: '12px'}} onClick={DeleteAddress}>{loading2?<FontAwesomeIcon icon={faCircleNotch} style={{fontSize: '20px', color: 'white', opacity: '0.5'}} spin />:'Delete'}</div>
            <div className={`myBtn w-100 text-center mt-5 bg-prime ${disable1?'disabled':null}`} style={{paddingTop: '12px',paddingBottom: '12px'}} onClick={!disable1 ? EditAddress : null}>{loading1?<FontAwesomeIcon icon={faCircleNotch} style={{fontSize: '20px', color: 'white', opacity: '0.5'}} spin />:'Save'}</div>
          </div>
        </Modal>
    </div>
    )
}

export default DepositSettings